import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { EmployeeService } from '../employee.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';

@Component({
  selector: 'itpx-employee-edit',
  templateUrl: './employee-edit.component.html',
  styleUrls: ['./employee-edit.component.css']
})
export class EmployeeEditComponent implements OnInit {

    private details: any;
    private sub: Subscription;
    private saveUrl: string;
    private cancelRoute: string = '/organization/users';
    private fields: any[];
    private id: string;
    private isInProgress: boolean = false;

    constructor(
            private employeeService: EmployeeService,
            private configService: ConfigService,
            private notificationService: NotificationService,
            private router: Router,
            private route: ActivatedRoute
    ) { }

    ngOnInit() {
        if (!this.employeeService.checkIfUserIsAdmin()) {
            this.router.navigate(['/404']);
        };
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.fields = this.employeeService.getEditFields();
            this.employeeService.getEmployeeDetails(this.id)
                .subscribe(
                    body => {
                        let details = <any>body['data'];
                        let accountGroups = details.roles ? details.roles.filter(role => role.configKey != 'instructor') : [];
                        let rolesFlat = [];
                        accountGroups.forEach(element => {
                            rolesFlat.push(element.id);
                        });
                        details.roles = rolesFlat;
                        this.details = details;
                        this.details.activeInitial = this.details.active;
                    }
                );
        });
        this.saveUrl = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.edit.api;
    }

    private onSaveFinished(employee: any) {
        if(employee.roles && employee.roles.length) {
            let result = [];
            employee.roles.forEach(id => {
                result.push({id: id});
            });
            employee.roles = result;
        }

        this.edit(employee);
    }

    private edit(employee: any) {
        this.isInProgress = true;
        //todo add a toggle button
        if(employee.active != this.details.activeInitial){
            if(employee.active == true){
                this.employeeService.activate(employee)
                .subscribe();
            }else{
                this.employeeService.deactivate(employee)
                .subscribe();
            }
            this.details.activeInitial = employee.active;
        }

        this.employeeService.edit(employee)
            .subscribe(
                body => {
                    this.isInProgress = false;
                    this.notificationService.success('Successfully edited the employee', 'Success');
                    this.router.navigate(['/organization/users/:id/details', { id: this.id }]);
                },
                error => this.isInProgress = false
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/employees/edit/employee-edit.component.ts